import API from './fetch'
import { hotelListUrl } from './url'
import { appendParams } from 'utilities/paramsFormat'

const Hotels = {
  getFacilities(params = {}) {
    const url = appendParams(hotelListUrl(), params)
    return API.getData(url)
  }
}

export default Hotels
